var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0807 3.33594H7.91406L5.83073 5.83594H3.33073C2.8887 5.83594 2.46478 6.01153 2.15222 6.32409C1.83966 6.63665 1.66406 7.06058 1.66406 7.5026V15.0026C1.66406 15.4446 1.83966 15.8686 2.15222 16.1811C2.46478 16.4937 2.8887 16.6693 3.33073 16.6693H16.6641C17.1061 16.6693 17.53 16.4937 17.8426 16.1811C18.1551 15.8686 18.3307 15.4446 18.3307 15.0026V7.5026C18.3307 7.06058 18.1551 6.63665 17.8426 6.32409C17.53 6.01153 17.1061 5.83594 16.6641 5.83594H14.1641L12.0807 3.33594Z",
    stroke: "#848588",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3359C11.3807 13.3359 12.5 12.2166 12.5 10.8359C12.5 9.45523 11.3807 8.33594 10 8.33594C8.61929 8.33594 7.5 9.45523 7.5 10.8359C7.5 12.2166 8.61929 13.3359 10 13.3359Z",
    stroke: "#848588",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.8da1aaab3bdcbde5d41045f000c5f2f6.svg";
export { ForwardRef as ReactComponent };